import { colors } from 'styles';

export default {
  accent: {
    print: colors.brandedTeal.dark,
    web: colors.brandedTeal.base,
  },
  graph: {
    background: {
      print: colors.cascade.muted,
      web: colors.shasta.dark,
    },
    foreground: {
      print: colors.brandedTeal.dark,
      web: colors.brandedTeal.base,
    },
    marker: {
      print: colors.white,
      web: colors.sierra.base,
    },
  },
  primary: {
    print: colors.sierra.base,
    web: colors.white,
  },
};
